var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBad = function SvgBad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.95 0a5.9 5.9 0 0 1 5.658 4.231 8 8 0 0 1 10.176 10.113 5.902 5.902 0 0 1 0 11.31 8 8 0 0 1-10.13 10.13 5.901 5.901 0 0 1-11.31 0 8 8 0 0 1-10.13-10.13 5.902 5.902 0 0 1 0-11.31A8 8 0 0 1 14.299 4.2 5.9 5.9 0 0 1 19.95 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.85,
    cy: 17,
    r: 1.667,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.141,
    cy: 17,
    r: 1.667,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.37,
    d: "M15 24.666c0-1.061.527-2.079 1.465-2.829.937-.75 2.209-1.171 3.535-1.171s2.598.421 3.535 1.171S25 23.605 25 24.666"
  })));
};
export default SvgBad;